<template>
    <div>
        <eqt-table
           :icon="icon"
           :color="color"
           :header-color="headerColor"
           :hide-search="hideSearch"
           :hide-pagination="hidePagination"
           :hide-show-btn="hideShowBtn"
           :hide-edit-btn="hideEditBtn"
           @refresh="refresh"
           :total="total"
           :loading="loading"
           :title="computedTitle"
           :items="items"
           hide-actions
           :headers="computedHeaders">
                <template slot="filters">
                    <v-flex lg4>
                        <v-autocomplete
                            :search-input.sync="qProduct"
                            v-model="data.products"
                            :items="products"
                            :loading="productsLoading"
                            name="products"
                            color="indigo"
                            hide-no-data
                            hide-selected
                            clearable
                            multiple
                            item-text="name"
                            item-value="id"
                            :label="$t('Pages.Products.title_singular')"
                            :placeholder="$t('Common.type_to_search')"
                            prepend-icon="mdi-package-down"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex lg4>
                        <v-autocomplete
                            :search-input.sync="qWarehouse"
                            v-model="data.warehouses"
                            :items="warehouses"
                            :loading="warehousesLoading"
                            name="warehouses"
                            color="indigo"
                            hide-no-data
                            hide-selected
                            clearable
                            multiple
                            item-text="name"
                            item-value="id"
                            :label="$t('Pages.Warehouses.title_singular')"
                            :placeholder="$t('Common.type_to_search')"
                            prepend-icon="home_work"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex lg1>
                        <v-tooltip top>
                            <v-btn
                                slot="activator"
                                absolute
                                right
                                small
                                fab
                                dark
                                color="indigo dark1"
                                @click="refresh(null, 1)">
                                <v-icon dark>mdi-download</v-icon>
                            </v-btn>
                            <span>{{$t('Core.Fields.download')}}</span>
                        </v-tooltip>
                    </v-flex>
                </template>
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.product.name }}</td>
                    <td class="text-xs-center">{{ item.productSize ? item.productSize.description : null }}</td>
                    <td class="text-xs-center">{{ item.warehouse.name }}</td>
                    <td class="text-xs-center">{{ item.state }}</td>
                    <slot name="items" :item="item"></slot>
                </template>
        </eqt-table>

    </div>
</template>

<script>
    import EqtTable from '../../../components/core/Table'
    import i18n from '@/i18n'
    import _ from "lodash";
    export default {
        name: "reports-table",
        components: {EqtTable},
        props: {
            items: {
              type: Array,
              required: true
            },
            total: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                default: false
            },
            hideActions: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: ''
            },
            color: {
                type: String,
                default: 'tertiary'
            },
            headerColor: {
                type: String,
                default: 'text-primary text--darken-3'
            },
            title: {
                type: String,
                default: null,
            },
            hidePagination: {
                type: Boolean,
                default: false
            },
            hideSearch: {
                type: Boolean,
                default: false
            },
            hideShowBtn: {
                type: Boolean,
                default: false
            },
            hideEditBtn: {
                type: Boolean,
                default: false
            },
            sortable: {
                type: Boolean,
                default: true
            },
            appendHeaders: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                headers: [
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.Products.title_singular'),
                        value: 'product.name',
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.ProductSizes.title_singular'),
                        value: 'productSize.description',
                        align: 'center'
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.Warehouses.title_singular'),
                        value: 'warehouse.name',
                        align: 'center'
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.WarehouseStates.model.state'),
                        value: 'state',
                        align: 'center'
                    },
                ],
                data: {},
                search: { product: null, warehouse: null },
                qProduct: null,
                products: [],
                productsLoading: false,
                qWarehouse: null,
                warehouses: [],
                warehousesLoading: false,
            };
        },
        computed:{
            computedHeaders(){
                return this.headers.concat(this.appendHeaders);
            },
            computedTitle(){
                return this.title ? this.title : this.$t('Pages.Reports.warehouse_states_title');
            },
        },
        methods: {
            refresh(data, shouldExport = 0){
                if(data) {
                    this.data = data;
                }
                else{
                    data = this.data;
                }

                data.export = shouldExport;

                this.$emit('refresh', data);
            },
        },
        watch: {
            qProduct: _.debounce(function(val){
                if(!val) return;
                // Items have already been loaded
                if (val.length < 2) return;

                // Items have already been requested
                if (this.productsLoading) return;

                this.productsLoading = true;
                this.repositories.product.all(val).then((response) => {
                    this.products = response.data.data;
                }).finally(() => {
                    this.productsLoading = false;
                });
            }, 500),
            qWarehouse: _.debounce(function(val){
                if(!val) return;
                // Items have already been loaded
                if (val.length < 2) return;

                // Items have already been requested
                if (this.warehousesLoading) return;

                this.warehousesLoading = true;
                this.repositories.warehouse.all(val).then((response) => {
                    this.warehouses = response.data.data;
                }).finally(() => {
                    this.warehousesLoading = false;
                });
            }, 500),
            'data.products': function () {
                this.refresh();
            },
            'data.warehouses': function () {
                this.refresh();
            }
        }
    }
</script>

<style scoped>

</style>
